import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const SortOrderZtoA = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M1.5 4c0-.28.22-.5.5-.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Zm0 4c0-.28.22-.5.5-.5h4.5a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Zm.5 3.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1H2Zm7.15-1.07a.5.5 0 0 1-.01-.7l3-3.08a.5.5 0 0 1 .72 0l3 3.08a.5.5 0 0 1-.72.7L13 8.22V14a.5.5 0 0 1-1 0V8.23l-2.15 2.2c-.19.2-.5.2-.7 0Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default SortOrderZtoA
